import logger from '../../log';
import compareVersions from 'compare-versions';
import { Ecdn10Data } from '../../ecdn10/interfaces';
import { LegacyEcdn10Data } from '../../priming/interfaces';

const log = logger.getLogger(__filename);
const MIN_10_AGENT_VERSION = '10.6';
export type EcdnTenData = Ecdn10Data | LegacyEcdn10Data;

const hasAgentDataAnd10Agent = (ecdn10: EcdnTenData): boolean => {
  if (!ecdn10.success) {
    log.info('ecdn10 not available');
    return false;
  }
  const { version } = (ecdn10 && ecdn10.agentData) || {};
  if (!version || compareVersions(version, MIN_10_AGENT_VERSION) < 0) {
    log.info('ecdn10 version too low', version);
    return false;
  }
  return true;
};

export default hasAgentDataAnd10Agent;
